import React from 'react';

import LandingView from './Landing.view';
import LandingContainer from './Landing.container';

const Landing = ({ onEndQuiz }) => {
  return (
    <LandingContainer>
      {({
        reports,
        title,
        remainingRound,
        totalRound,
        onStartQuiz,
        onSeeReport,
        isQuizStarting,
        timeLimit,
        fullScore,
        passingScore,
        resultOptions,
        variant,
        openCourseReviewModal,
        isLastSubsectionInCourse,
        onExitClassroom,
      }) => {
        return (
          <LandingView
            variant={variant}
            title={title}
            remainingRound={remainingRound}
            totalRound={totalRound}
            timeLimit={timeLimit}
            fullScore={fullScore}
            passingScore={passingScore}
            resultOptions={resultOptions}
            reports={reports}
            onStartQuiz={onStartQuiz}
            onSeeReport={onSeeReport}
            onGoToNextSubsection={onEndQuiz}
            disableStartQuizButton={isQuizStarting}
            openCourseReviewModal={openCourseReviewModal}
            isLastSubsectionInCourse={isLastSubsectionInCourse}
            onExitClassroom={onExitClassroom}
          />
        );
      }}
    </LandingContainer>
  );
};

export default Landing;
